// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { AuthProvider } from './hooks/useAuth';
import { FinanceProvider } from './context/FinanceContext';
import { TradingProvider } from './context/TradingContext';
import { MindProvider } from './context/MindContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import BankIntelligence from './pages/BankIntelligence';
import WealthEngine from './pages/WealthEngine';
import IntelligenceFeed from './pages/IntelligenceFeed';
import OrderTracker from './pages/OrderTracker';
import PasswordVault from './pages/PasswordVault';
import ImpactCalculator from './pages/ImpactCalculator';
import Settings from './pages/Settings';
import TradingPortal from './pages/TradingPortal';
import ProtectedRoute from './routes/ProtectedRoute';
import MainLayout from './layouts/MainLayout';

export default function App() {
  return (
    <AuthProvider>
      <FinanceProvider>
        <TradingProvider>
          <MindProvider>
          <BrowserRouter>
            <Routes>
              {/* Public */}
              <Route path="/login" element={<Login />} />

              {/* Protected area — all pages require Firebase auth */}
              <Route element={<ProtectedRoute />}>
                <Route element={<MainLayout />}>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/bank" element={<BankIntelligence />} />
                  <Route path="/wealth" element={<WealthEngine />} />
                  <Route path="/intelligence" element={<IntelligenceFeed />} />
                  <Route path="/orders" element={<OrderTracker />} />
                  <Route path="/vault" element={<PasswordVault />} />
                  <Route path="/calculator" element={<ImpactCalculator />} />
                  <Route path="/trading" element={<TradingPortal />} />
                  <Route path="/settings" element={<Settings />} />
                </Route>
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          </MindProvider>
        </TradingProvider>
      </FinanceProvider>
    </AuthProvider>
  );
}
